module.exports = __webpack_public_path__ + "static/media/frc-halloween-image-3.26c0e8d8.png";